import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { Dialog, DialogContent, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import promotion_bg from '../images/BG-True_44.jpg';
import { useTranslation } from 'react-i18next';

const PromotionDialog = ({ open, onClose }) => {
  const { t: popup_promo } = useTranslation('popup_promo');

  const [internalOpen, setInternalOpen] = useState(false);

  // Auto-open on first mount so the dialog appears without parent control
  useEffect(() => {
    setInternalOpen(true);
  }, []);

  const handleClose = onClose ? onClose : () => setInternalOpen(false);

  return (
    <Dialog
      open={open ?? internalOpen}
      onClose={onClose}
      fullScreen={useMediaQuery('(max-width:1200px)')}
      keepMounted
      container={typeof document !== 'undefined' ? document.body : undefined}
      PaperProps={{
        sx: {
          // backgroundImage: `url(${promotion_bg})`,
          backgroundImage: `url("https://s3.ap-southeast-1.amazonaws.com/boatrental.trueleasing.co.th/shareticket/popup_AYT_flood_2025.png")`,
          backgroundSize: '100% auto',
          borderRadius: '10px',
          padding: '20px',
          margin: '10px',
          maxWidth: '800px',
          width: '100%',
          height: '515px',
          boxShadow: '0 0 5px #55D0E4',
          border: '1px solid rgba(218, 165, 32, 0.1)',
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ padding: '0px 20px 0px 20px' }}>
        {/* <Box>
          <Box sx={{ display: 'flex', mb: 4, pb: 3, justifyContent: 'center', borderBottom: '1px solid #ddd' }}>
            <Typography sx={{ fontSize: '36px', fontWeight: 'bold', padding: 2, color: '#00a9dd', textShadow: '1px 1px 8px #fff' }}>
              {popup_promo('title')}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 'bold', padding: 2, paddingTop: 0, paddingBottom: 1, color: '#00a9dd' }}>
              {popup_promo('title1')}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 15, padding: 2, paddingTop: 0, color: '#333' }} gutterBottom>
              {popup_promo('description1')}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 'bold', padding: 2, paddingBottom: 0, color: '#00a9dd' }}>
              {popup_promo('title2')}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 15, padding: 2, paddingTop: 0, color: '#333' }} gutterBottom>
              {popup_promo('description2')}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 'bold', padding: 2, paddingBottom: 0, color: '#00a9dd' }}>
              {popup_promo('title3')}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 15, padding: 2, paddingTop: 0, color: '#333' }} gutterBottom>
              {popup_promo('description3')}
            </Typography>
          </Box>
        </Box> */}
      </DialogContent>
    </Dialog>
  );
};

export default PromotionDialog;
